import { useQuery } from 'react-query'
import React from "react";
import { fetchTrialSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function RegByRepWithRegion({ date }) {
    const fetchData = async () => {
        const { data } = await fetchTrialSignUpsExplorer('regByRepWithRegion', date);
        if (data.result && data.result.data) return data.result;
        return { ...data.result, data: [] }; // Ensure data is always an array
    };

    const { data, error, isError, isLoading } = useQuery(
        ['trialsRegByRepWithRegion', date],
        fetchData,
        {
            refetchOnWindowFocus: false,
        }
    );
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={"regByRepWithRegion" + date}  {...dataProps } />
}
export default RegByRepWithRegion